import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  completeMcpOAuthConnect,
  type CompleteMcpOAuthConnectPayload,
} from '@/api/v4/mcp-oauth.api';
import { QueryKey } from '@/config/query-client';

export const useCompleteMcpOAuthConnect = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: CompleteMcpOAuthConnectPayload) =>
      completeMcpOAuthConnect(payload),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.McpOAuthGrants],
      });
    },
  });
};
